import useI18n from '@/shared/hooks/useI18n'
import { Badge, Button, TableCell, TableRow } from '@/common'
import { OrganizationUser } from '@/api/OrganizationUserModel'
import OrganizationUserPermissionsDialog from '../../../components/OrganizationUserPermissionsDialog'
import { useDialog } from '@/shared/hooks/useDialog'
import { useSession } from '@/shared/hooks/useSession'
import OrganizationUserDeleteDialog from '@/features/organization/users/components/OrganizationUserDeleteDialog'

export default function OrganizationUsersTableRow({ user }: { user: OrganizationUser }) {
  const { t } = useI18n()
  const {
    session: { id: selfUserId }
  } = useSession()
  const {
    openDialog: openApprovalDialog,
    closeDialog: closeApprovalDialog,
    open: isApprovalDialogOpen
  } = useDialog()
  const {
    openDialog: openDeleteDialog,
    closeDialog: closeDeleteDialog,
    open: isDeleteDialogOpen
  } = useDialog()

  const userRoles = user.permissions.map(permission =>
    t(`organizationUsers:roles.${permission.roleSlug}`)
  )

  return (
    <>
      <TableRow>
        <TableCell>
          {user.firstName} {user.lastName}
        </TableCell>
        <TableCell className="space-y-2">
          <div>{user.email}</div>
          {user.passwordResetRequired && (
            <Badge variant="yellow">
              {t('organizationUsers:invitationStats.passwordResetRequired')}
            </Badge>
          )}
        </TableCell>
        <TableCell>{userRoles.join(', ')}</TableCell>
        <TableCell>
          <div className="flex items-center justify-end gap-2">
            {user.id !== selfUserId && (
              <Button sizeType="sm" variant="danger" onClick={openDeleteDialog}>
                {t('organizationUsers:actions.deleteUser')}
              </Button>
            )}
            <Button sizeType="sm" variant="subtle" onClick={openApprovalDialog}>
              {t('organizationUsers:actions.editPermissions')}
            </Button>
          </div>
        </TableCell>
      </TableRow>
      <OrganizationUserPermissionsDialog
        onAfterLeave={() => {}}
        isOpen={isApprovalDialogOpen}
        user={user}
        onApprove={() => {}}
        close={closeApprovalDialog}
      />
      <OrganizationUserDeleteDialog
        isOpen={isDeleteDialogOpen}
        user={user}
        close={closeDeleteDialog}
      />
    </>
  )
}
